import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const MatrixLinearTransformationModule = () => (
  <QPhototModuleSubtopic
    title="Matrix Representation of Linear Transformation"
    videos={[
      "https://www.youtube.com/embed/PNI6YANwIF0",
      "https://www.youtube.com/embed/wkUEeHzdmbY"
    ]}
    takeaways={[
      {image:"/cvla_79.png"},
      {image:"/cvla_80.png"},
    ]}
    questions={[
      {image:"/cvla_81.png"},
      {image:"/cvla_82.png"},
      {image:"/cvla_83.png"},
      {image:"/cvla_84.png"},
      {image:"/cvla_85.png"},

    ]}
    exampleVideos={[]}
  />
);

export default MatrixLinearTransformationModule;
